import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import {
  ResourceByIdDocument,
  ResourceByIdQuery,
} from 'src/graphql/generated/graphql';
import { ResourceListItem } from '../../../types';
import { PartialResourcePage } from 'src/components/resource/form/types';

type UseFullResourceProps = {
  resource: ResourceListItem | PartialResourcePage | null;
};

export const useFullResource = ({ resource }: UseFullResourceProps) => {
  const [shouldGetFullResource, setShouldGetFullResource] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const { data: fullResource } = useQuery<ResourceByIdQuery>(
    ResourceByIdDocument,
    {
      variables: {
        id: resource?.id,
      },
      skip: !shouldGetFullResource,
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only',
    },
  );

  useEffect(() => {
    if (fullResource && isDownloading) {
      setIsDownloading(false);

      if (
        fullResource.resourceById.items[0].currentFileVersion?.fileAsset.url
      ) {
        window.open(
          fullResource.resourceById.items[0].currentFileVersion.fileAsset.url,
          '_blank',
        );
      }
    }
  }, [fullResource, isDownloading]);

  const onDownload = () => {
    setIsDownloading(true);
    setShouldGetFullResource(true);
  };

  const onPlay = () => {
    setIsPlaying(true);
    setShouldGetFullResource(true);
  };

  const onClosePlay = (event: Object) => {
    if (
      'stopPropagation' in event &&
      typeof event.stopPropagation === 'function'
    ) {
      event.stopPropagation();
    }

    setIsPlaying(false);
  };

  return {
    fullResource,
    isDownloading,
    isPlaying,
    onDownload,
    onPlay,
    onClosePlay,
  };
};
